import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class militaryBaseGuideView_template extends vnTemplate {
    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <button data-bind="click: onClickBack" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title icon i-summary" data-bind="text: title">Military Base</h3>
                    <div class="w-btn">
                        <button type="button" data-bind="visible: slug, click: onClickViewOnSite" class="btn icon border only-icon i-link"></button>
                        <button data-bind="click: onClickEdit" class="btn icon i-edit" type="button">Edit Military Base</button>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title no-margin">Base Details</strong>
                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Short Name</label>
                                <div data-bind="text: shortName"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Slug</label>
                                <div data-bind="text: slug"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Base Group</label>
                                <div data-bind="text: baseGroup"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Status</label>
                                <div data-bind="text: status() ? 'Active' : 'Inactive'"></div>
                            </div>
                        </div>
                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Base Image</label>
                                <div data-bind="visible: !baseImage()">No image selected.</div>
                                <div class="w-img" data-bind="visible: baseImage() && baseImage().url">
                                    <img data-bind="attr: { src: baseImage() ? baseImage().url : '', alt: baseImage() && baseImage().altText ? baseImage().altText : '' }" alt="" />
                                </div>
                                <div data-bind="visible: baseImage() && !baseImage().url, text: 'Selected image ID: ' + baseImage()"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Images</label>
                                <div data-bind="visible: images().length == 0">No images selected.</div>
                                <ul class="img-picker-list selected" data-bind="foreach: images, visible: images().length > 0">
                                    <li class="img-picker-item">
                                        <div class="ratio-content">
                                            <img data-bind="attr: { src: url ? url + '?w=300&h=300' : '', alt: altText || '' }" alt="" />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <strong class="form-sub-title">Address</strong>
                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Street 1</label>
                                <div data-bind="text: addressStreet1"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Street 2</label>
                                <div data-bind="text: addressStreet2"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Zip Code</label>
                                <div data-bind="text: addressZipCode"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Building Number</label>
                                <div data-bind="text: addressBuildingNumber"></div>
                            </div>
                        </div>
                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Cross Street</label>
                                <div data-bind="text: addressCrossStreet"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">City</label>
                                <div data-bind="text: addressCity"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">State</label>
                                <div data-bind="text: addressState"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Country</label>
                                <div data-bind="text: addressCountry"></div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Body</label>
                            <div data-bind="html: body"></div>
                        </div>
                    </div>
                </div>

                <div class="w-list-results">
                    <table class="list-results">
                        <thead>
                            <tr>
                                <th>Help Service Category</th>
                                <th>Help Service</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: helpServiceRows">
                            <tr>
                                <td data-bind="text: category.name"></td>
                                <td>
                                    <div class="flex">
                                        <span data-bind="text: helpService ? helpService.title : 'Not created'"></span>
                                        <button type="button" data-bind="visible: helpService && helpService.slug, event: { click: $parent.onClickHelpServiceOnSite }" class="btn icon border only-icon i-link"></button>
                                    </div>
                                </td>
                                <td data-bind="text: helpService ? (helpService.status ? 'Active' : 'Inactive') : ''"></td>
                                <td>
                                    <button class="btn icon border only-icon" type="button" data-bind="click: $parent.onClickHelpService, class: helpService ? 'i-edit': 'i-add'">
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "militaryBaseGuideView-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            idBrand: ko.observable(null),
            id: ko.observable(null),
            title: ko.observable(""),
            shortName: ko.observable(""),
            slug: ko.observable(""),
            baseGroup: ko.observable(""),
            status: ko.observable(true),
            body: ko.observable(""),
            baseImage: ko.observable(null),
            images: ko.observableArray([]),
            addressStreet1: ko.observable(""),
            addressStreet2: ko.observable(""),
            addressZipCode: ko.observable(""),
            addressBuildingNumber: ko.observable(""),
            addressCrossStreet: ko.observable(""),
            addressCity: ko.observable(""),
            addressState: ko.observable(""),
            addressCountry: ko.observable(""),
            helpServiceRows: ko.observableArray([]),
            onClickBack: function () {
                self.caller.cancel();
            },
            onClickEdit: function () {
                self.caller.editBase();
            },
            onClickHelpService: function (row) {
                self.caller.editHelpService(row);
            },
            onClickHelpServiceOnSite: function (row, event) {
                return self.onClickHelpServiceOnSite(row, event);
            },
            onClickViewOnSite: function (data, event) {
                return self.onClickViewOnSite(data, event);
            }
        };
    }

    public setBrand(idBrand): void {
        this.getTemplateViewModel().idBrand(idBrand);
    }

    public setBase(base): void {
        const vm = this.getTemplateViewModel();
        const address = base.address || {};
        vm.id(base.id);
        vm.title(base.title);
        vm.shortName(base.shortName);
        vm.slug(base.slug);
        vm.baseGroup(base.baseGroup);
        vm.status(base.status);
        vm.body(base.body);
        vm.baseImage(base.baseImage || base.idBaseImage || null);
        vm.images(base.images || []);
        vm.addressStreet1(address.street1 || "");
        vm.addressStreet2(address.street2 || "");
        vm.addressZipCode(address.zipCode || "");
        vm.addressBuildingNumber(address.buildingNumber || "");
        vm.addressCrossStreet(address.crossStreet || "");
        vm.addressCity(address.city || "");
        vm.addressState(address.state || "");
        vm.addressCountry(address.country || "");
    }

    public setHelpServiceRows(rows): void {
        this.getTemplateViewModel().helpServiceRows(rows);
    }

    protected onClickHelpServiceOnSite(row, event): boolean {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.caller.viewHelpServiceOnSite(row.helpService);
        return false;
    }

    protected onClickViewOnSite(data, event): boolean {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const vm = this.getTemplateViewModel();

        this.caller.viewBaseOnSite(vm.slug());
        return false;

    }
}



// WEBPACK FOOTER //
// ./js/components/templates/militaryBaseGuideView_template.ts